/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who3_TitleInputs */

const en_dr_who3_title = /** @type {(inputs: Dr_Who3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campuses & advisors`)
};

const id_dr_who3_title = /** @type {(inputs: Dr_Who3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampus & dosen pembimbing`)
};

/**
* | output |
* | --- |
* | "Campuses & advisors" |
*
* @param {Dr_Who3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who3_title = /** @type {((inputs?: Dr_Who3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who3_title(inputs)
	return en_dr_who3_title(inputs)
});